import { SEO } from "./SEO";

export function LoginSEO() {
  return (
    <SEO title="Login - Lucky Kids" description="Log in to your account." />
  );
}
